import React, { useContext } from "react";
import MsmContext from "../../reducers/Context";

const SignupComplete = () => {
  const { dispatch, state } = useContext(MsmContext);

  return (
    <div className="afs-msm-stage-content add-all-padding add-vert-margin">
      <p>Your details have been sent to {state.team.TeamSiteDisplayName} to create your account, please contact them for any updates.</p>
    </div>
  );
};

export default {
  id: "signup-complete",
  title: "We'll let them know...",
  subtitles: [""],
  imageUrl: "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-2.jpg",
  component: SignupComplete,
};
